let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bTgJ4")).then(() => parcelRequire('86mLg'));